import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69792001921dc90014b185df_1785406395352_bbb2f099/golddreams/src/app/privacy-policy/page.tsx");
